// Service card section scaffold (single service summary).
import Button from "../../ui/Button";
import {
  Megaphone,
  Users,
  Lightbulb,
  Share2,
  Palette,
  Target,
} from "lucide-react";

function pickServiceIcon(title = "") {
  const t = String(title).toLowerCase();

  // Ads / campaigns
  if (t.includes("حملات") || t.includes("ads") || t.includes("advert")) return Megaphone;

  // Influencers
  if (t.includes("المؤثر") || t.includes("influencer")) return Users;

  // Consulting
  if (t.includes("استشارات") || t.includes("consult")) return Lightbulb;

  // Social media management
  if (
    t.includes("التواصل") ||
    t.includes("وسائل") ||
    t.includes("social") ||
    t.includes("media")
  )
    return Share2;

  // Branding / identity / logo
  if (
    t.includes("هوية") ||
    t.includes("الشعارات") ||
    t.includes("branding") ||
    t.includes("logo") ||
    t.includes("identity")
  )
    return Palette;

  // Strategy / plan
  if (t.includes("خطة") || t.includes("plan") || t.includes("strategy")) return Target;

  return Target;
}

export default function ServiceCard({ title, desc, details, orderText, index = 0 }) {
  const Icon = pickServiceIcon(title);
  return (
    <div
      className="service-card"
      data-aos="fade-up"
      data-aos-delay={index * 120}
    >
      <div className="service-icon" aria-hidden="true">
        <Icon />
      </div>
      <h3>{title}</h3>
      <p>{desc}</p>
      <ul className="service-details">
        <hr />
        {details.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
      <Button to="/request" variant="primary" className="btn">
        {orderText}
      </Button>
    </div>
  );
}

